import { render, staticRenderFns } from "./ServiceFormModal.vue?vue&type=template&id=3825ba28&"
import script from "./ServiceFormModal.vue?vue&type=script&lang=js&"
export * from "./ServiceFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormModal.vue?vue&type=style&index=0&id=3825ba28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports